import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Tooltip } from "antd";
import { LineChartOutlined, SettingOutlined } from "@ant-design/icons";
import styles from "./GroupConfigureEmptyState.module.scss";

const CONFIG_STEP_KEYS = ["1", "2", "3"];

export default function GroupConfigureEmptyState({
  onConfigure,
  disabled = false,
  disabledTooltip,
  className,
}) {
  const { t } = useTranslation();

  const configureButton = (
    <Button
      type="primary"
      size="large"
      icon={<SettingOutlined />}
      onClick={onConfigure}
      disabled={disabled}
      className={styles.configureButton}
    >
      {t("welcome.groupConfigureButton")}
    </Button>
  );

  return (
    <div className={[styles.root, className].filter(Boolean).join(" ")}>
      <div className={styles.panel}>
        <div className={styles.iconWrap} aria-hidden>
          <LineChartOutlined className={styles.icon} />
        </div>

        <div className={styles.content}>
          <h4 className={styles.title}>{t("welcome.groupConfigureEmptyTitle")}</h4>
          <p className={styles.description}>
            {t("welcome.groupConfigureEmptyDescription")}
          </p>

          <p className={styles.stepsInline}>
            {CONFIG_STEP_KEYS.map((stepKey, index) => (
              <React.Fragment key={stepKey}>
                {index > 0 ? (
                  <span className={styles.stepsSep} aria-hidden>
                    ·
                  </span>
                ) : null}
                <span className={styles.stepsItem}>
                  <span className={styles.stepsNum}>{stepKey}</span>
                  {t(`welcome.groupConfigureStep${stepKey}Title`)}
                </span>
              </React.Fragment>
            ))}
          </p>

          <div className={styles.actions}>
            {disabled && disabledTooltip ? (
              <Tooltip title={disabledTooltip}>
                <span className={styles.configureButtonWrap}>{configureButton}</span>
              </Tooltip>
            ) : (
              configureButton
            )}
            <p className={styles.durationHint}>
              {t("welcome.groupConfigureDurationHint")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
